import { usarDebounces } from "@/composable/UsarDebounces/usarDebounces"
import { FuncaoDebouncer, Propriedades, PosicionamentosDeRolagem } from "./usarRolagemInfinita.modelos"

const { debounce } = usarDebounces()

export function usarRolagemInfinita(props: Propriedades) {
  let elementoHTMLDeRolagem: HTMLElement | null = null
  let debouncerDeRolagem: FuncaoDebouncer | null = null
  let posicaoVerticalAnteriorDaRolagem = 0

  const buscarElementoDeRolagem = (): HTMLElement => {
    const elementoHTML = document.querySelector(props.querySelecaoListaDeItens) as HTMLElement

    if (!elementoHTML) {
      throw Error(`Não foi possível encontrar o elemento de rolagem com o seletor ${props.querySelecaoListaDeItens}`)
    }

    return elementoHTML
  }

  const montarDebouncerDeRolagem = (
    elementoDeLista: HTMLElement,
    acaoAoRolar: () => void
  ): FuncaoDebouncer => {

    const processarEventoDeRolagem = (): void => {
      const atualizarPosicaoVerticalAnteriorDaRolagem = (posicaoVertical: number) => {
        posicaoVerticalAnteriorDaRolagem = posicaoVertical
      }

      const realizarCalculosDePosicao = (): PosicionamentosDeRolagem => {
        const porcentagemEmDecimalDeRolagemParaCarregamento = 1
        const posicaoVerticalAtualDaRolagem = elementoDeLista.scrollTop
        const posicaoFinalDaRolagem = elementoDeLista.scrollHeight - elementoDeLista.clientHeight
        const posicaoParcialRecomendadaParaNovaBusca = posicaoFinalDaRolagem * porcentagemEmDecimalDeRolagemParaCarregamento

        return {
          posicaoVerticalAtualDaRolagem,
          posicaoParcialRecomendadaParaNovaBusca
        }
      }

      const verificarSeDeveExecutarAcao = ({
        posicaoVerticalAtualDaRolagem,
        posicaoParcialRecomendadaParaNovaBusca
      }: PosicionamentosDeRolagem) => {
        const rolouPraBaixo = posicaoVerticalAtualDaRolagem > posicaoVerticalAnteriorDaRolagem
        const atingiuPosicaoParcialRecomendadaParaNovaBusca = posicaoVerticalAtualDaRolagem >= posicaoParcialRecomendadaParaNovaBusca

        if (rolouPraBaixo && atingiuPosicaoParcialRecomendadaParaNovaBusca) {
          acaoAoRolar()
        }
      }

      const posicionamentosDeRolagem = realizarCalculosDePosicao()

      verificarSeDeveExecutarAcao(posicionamentosDeRolagem)
      atualizarPosicaoVerticalAnteriorDaRolagem(posicionamentosDeRolagem.posicaoVerticalAtualDaRolagem)
    }

    return debounce(processarEventoDeRolagem, props.atrasoRolagemInfinita)
  }

  const adicionarEventoDeRolagem = (): void => {
    elementoHTMLDeRolagem = buscarElementoDeRolagem()

    debouncerDeRolagem = montarDebouncerDeRolagem(elementoHTMLDeRolagem, () => {
      if (props.buscarMaisItens) {
        props.buscarMaisItens()
      }
    })
    elementoHTMLDeRolagem.addEventListener('scroll', debouncerDeRolagem)
  }

  const removerEventoDeRolagem = (): void => {
    if (elementoHTMLDeRolagem && debouncerDeRolagem) {
      elementoHTMLDeRolagem.removeEventListener('scroll', debouncerDeRolagem)
    }
  }

  return {
    adicionarEventoDeRolagem,
    removerEventoDeRolagem,
  }
}
